import { Injectable } from "@angular/core";
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";

import { AlertService } from "../services/alert.service";

@Injectable({ providedIn: 'root' })
export class HttpInterceptorService implements HttpInterceptor {
  constructor(
    public router: Router,
    public alert: AlertService,
    private toastr: ToastrService,
  ) {}

  private static readonly FALLBACK_MESSAGE = 'Something went wrong. Please try again.';

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        this.surfaceErrorToast(error);
        return throwError(error);
      }),
    );
  }

  /**
   * Show a toast for failed 400 requests.
   *
   * <p>Backend validation errors come back as
   * `{ code: 400, message: "...", devMessage: "..." }`. We prefer the
   * user-facing `message` when present, fall back to `devMessage`,
   * and finally to a generic message if neither is provided.
   */
  private surfaceErrorToast(error: HttpErrorResponse): void {
    if (error?.status !== 400) return;

    const text = this.pickMessage(error.error);
    this.toastr.error(text, '', {
      timeOut: 4500,
      closeButton: true,
      progressBar: true,
      tapToDismiss: true,
      positionClass: 'toast-top-right',
    });
  }

  private pickMessage(body: any): string {
    if (typeof body === 'string') {
      return body.trim() || HttpInterceptorService.FALLBACK_MESSAGE;
    }
    const message = typeof body?.message === 'string' ? body.message.trim() : '';
    if (message) return message;

    const devMessage = typeof body?.devMessage === 'string' ? body.devMessage.trim() : '';
    if (devMessage) return devMessage;

    return HttpInterceptorService.FALLBACK_MESSAGE;
  }
}
